/**
 * GA4 ecommerce events for Google Tag Manager (container loaded in
 * layout/theme.liquid). Pushes to window.dataLayer only — every tag is
 * configured inside GTM, not here.
 *
 * Event → source of its data:
 * - view_item_list: each homepage Portfolio section's
 *   [data-gtm-item-list] JSON, plus #GtmPageData on collection pages
 * - view_item: #GtmPageData on product pages (snippets/gtm-page-data.liquid)
 * - add_to_cart: product-page forms (submit to /cart/add, priced from
 *   #GtmPageData's variant map) and the Portfolio cards' AJAX add
 *   ('cart:item-added' event dispatched by sections/portfolio.liquid)
 * - view_cart: the cart section's [data-gtm-cart] JSON
 * - begin_checkout and purchase: NOT here — they come from a Customer
 *   events custom pixel in the Shopify admin (gtm-checkout-custom-pixel.js
 *   in the project root). Shopify's checkout_started catches every way into
 *   checkout, including "Buy it now" and express buttons the theme can't
 *   see, and checkout pages don't run theme code at all. Don't add a
 *   begin_checkout here too, or cart checkouts get counted twice.
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  function push(event, ecommerce) {
    // Clear the previous ecommerce object first, per Google's GA4 guidance,
    // so fields from one event can't leak into the next.
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: event, ecommerce: ecommerce });
  }

  function readJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function total(items) {
    return Math.round(
      items.reduce(function (sum, item) {
        return sum + item.price * (item.quantity || 1);
      }, 0) * 100
    ) / 100;
  }

  var pageData = readJson(document.getElementById('GtmPageData'));
  var currency = (pageData && pageData.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  function onReady() {
    if (pageData && pageData.type === 'product' && pageData.item) {
      push('view_item', {
        currency: pageData.currency,
        value: pageData.item.price,
        items: [pageData.item],
      });
    }

    if (pageData && pageData.type === 'collection' && pageData.items.length) {
      push('view_item_list', {
        item_list_name: pageData.list_name,
        items: pageData.items,
      });
    }

    document.querySelectorAll('[data-gtm-item-list]').forEach(function (el) {
      var list = readJson(el);
      if (!list || !list.items.length) return;
      push('view_item_list', {
        item_list_name: list.list_name,
        items: list.items,
      });
    });

    var cart = readJson(document.querySelector('[data-gtm-cart]'));
    if (cart && cart.items.length) {
      push('view_cart', { currency: cart.currency, value: cart.value, items: cart.items });
    }
  }

  // Product page add to cart: a normal form POST to /cart/add (the page
  // then navigates to /cart). Capture phase so it runs before any other
  // submit handler can stop the event.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (!pageData || pageData.type !== 'product') return;

      var data = new FormData(form);
      var variantId = String(data.get('id') || '');
      var quantity = parseInt(data.get('quantity'), 10) || 1;
      var base = pageData.variants[variantId] || pageData.item;
      var item = Object.assign({}, base, { quantity: quantity });

      push('add_to_cart', { currency: pageData.currency, value: total([item]), items: [item] });
    },
    true
  );

  // Homepage Portfolio card add to cart (AJAX, no navigation). detail.item
  // is the line item returned by /cart/add.js (prices in cents).
  document.addEventListener('cart:item-added', function (event) {
    var line = event.detail && event.detail.item;
    if (!line) return;

    var item = {
      item_id: String(line.product_id),
      item_name: line.product_title,
      price: (line.final_price != null ? line.final_price : line.price) / 100,
      quantity: event.detail.quantity || 1,
    };
    if (event.detail.brand) item.item_brand = event.detail.brand;
    if (event.detail.category) item.item_category = event.detail.category;
    if (line.variant_title) item.item_variant = line.variant_title;

    push('add_to_cart', { currency: currency, value: total([item]), items: [item] });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
